var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user.avatarUrl
    ? _c("img", {
        staticClass: "object-cover",
        attrs: { src: _vm.user.avatarUrl }
      })
    : _c("div", { staticClass: "overflow-hidden" }, [
        _c(
          "span",
          {
            staticClass:
              "w-full h-full text-xl flex items-center justify-center text-white bg-primary-500"
          },
          [_vm._v(" " + _vm._s((_vm.user.name || "?").substr(0, 1)) + " ")]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }